import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

export interface SuperUserDto {
    id: number;
    name: string;
    lastName: string;
    email: string;
    isActive: boolean;
    createdAt: string;
}

export interface SuperUserStatusChangeDto {
    isActive: boolean;
}

@Injectable({
    providedIn: 'root',
})
export class SuperUsersService {
    private apiUrl = 'superusers';

    constructor(private http: HttpClient) { }

    getAll(): Observable<SuperUserDto[]> {
        return this.http.get<SuperUserDto[]>(this.apiUrl);
    }

    changeStatus(id: number, dto: SuperUserStatusChangeDto): Observable<SuperUserDto> {
        return this.http.post<SuperUserDto>(`${this.apiUrl}/${id}/status`, dto);
    }
}
